module.exports = __webpack_public_path__ + "img/logo.da76a0f5.png";